// Copyright (c) 2019 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeHours,
    changeLaborComments,
    changeLaborLocation,
    changeLaborType,
    changeTechId,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    resetWearPartsClaim,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateStickyHeaderVisibility,
    updateWearPartsClaimFailureDate,
    updateWearPartsClaimFailurePart,
    updateWearPartsClaimFailureRemanIndicator,
    updateWearPartsClaimInputOnBlur,
    updateWearPartsClaimPin,
    updateWearPartsClaimRepairDate,
    updateWearPartsClaimRepairNumber,
    updateWearPartsClaimUnitDropDown,
    updateWearPartsClaimUseAmount,
    updateWearPartsClaimWorkOrderOne,
    updateWearPartsClaimWorkOrderTwo
} from './claim-details';
import {
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updateWearPartsClaimBasisForSettlement,
    updateWearPartsClaimComplaintCause,
    updateWearPartsClaimComplaintCorrection,
    updateWearPartsClaimDtacCase,
    updateWearPartsClaimDtacSolution,
    updateWearPartsClaimFailedArea,
    updateWearPartsClaimFailedModeComments,
    updateWearPartsClaimOperatorComments,
    updateWearPartsClaimOperatorsComplaint,
    updateWearPartsClaimPartSerialNumber
} from './failure-panel';
import {
    updateNonTrackedPinModalAccount,
    updateNonTrackedPinModalFailureDate,
    updateNonTrackedPinModalInvoiceDate,
    updateNonTrackedPinModalInvoiceNumber,
    updateNonTrackedPinModalPin
} from './pin';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createPin} from './create-pin';
import {createWearPartsClaim} from './validate-claim';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readDownTime} from '../../shared/action-creators/down-time';
import {readFailureModes} from './failure-modes';
import {readGoodsInstallationVatOptions} from '../../shared/action-creators/get-goods-installation-vat-options';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readOwnershipStatuses} from '../../shared/action-creators/ownership-status';
import {readPartDetails} from './get-part-details';
import {readWearPartsClaim} from './get-wear-parts-claim';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {resetProductDetails} from './reset-product-details';
import {toggleWarrentyStatusModal} from '../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updateNonTrackedPinModalVisibility} from './non-tracked-pin-modal-visibility';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../product/details/action-creators/warranties';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeHours,
    changeLaborComments,
    changeLaborLocation,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    changeTechId,
    copyAttachments,
    copyClaim,
    createOtherCredit,
    createPin,
    createWearPartsClaim,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readClaimProduct,
    readClaimTypes,
    readDownTime,
    readFailureModes,
    readGoodsInstallationVatOptions,
    readLaborLocations,
    readLaborTypes,
    readOtherCreditDescriptions,
    readOwnershipStatuses,
    readPartDetails,
    readWearPartsClaim,
    resetCkcCustomerFailure,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetProductDetails,
    resetWearPartsClaim,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updateGoodsInstallationVat,
    updateIsEditable,
    updateNonTrackedPinModalAccount,
    updateNonTrackedPinModalFailureDate,
    updateNonTrackedPinModalInvoiceDate,
    updateNonTrackedPinModalInvoiceNumber,
    updateNonTrackedPinModalPin,
    updateNonTrackedPinModalVisibility,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateWarranties,
    updateWearPartsClaimBasisForSettlement,
    updateWearPartsClaimComplaintCause,
    updateWearPartsClaimComplaintCorrection,
    updateWearPartsClaimDtacCase,
    updateWearPartsClaimDtacSolution,
    updateWearPartsClaimFailedArea,
    updateWearPartsClaimFailedModeComments,
    updateWearPartsClaimFailureDate,
    updateWearPartsClaimFailurePart,
    updateWearPartsClaimFailureRemanIndicator,
    updateWearPartsClaimInputOnBlur,
    updateWearPartsClaimOperatorComments,
    updateWearPartsClaimOperatorsComplaint,
    updateWearPartsClaimPartSerialNumber,
    updateWearPartsClaimPin,
    updateWearPartsClaimRepairDate,
    updateWearPartsClaimRepairNumber,
    updateWearPartsClaimUnitDropDown,
    updateWearPartsClaimUseAmount,
    updateWearPartsClaimWorkOrderOne,
    updateWearPartsClaimWorkOrderTwo
};



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/index.js